import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CardsGrid = styled.div`
  display: grid;
  gap: ${Spacing.S16};
  grid-template-columns: repeat(3, 1fr);
`

export const Card = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${Spacing.S12};
  min-width: 0;
  padding: ${Spacing.S24};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
  text-align: center;
`

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${Spacing.S40};
  height: ${Spacing.S40};
  border-radius: 50%;
  background-color: ${Color.Purple50};
`
